export enum Policy {
	SignUpSignIn,
	EditProfile,
	ResetPassword,
	// ChangeEmailAddress,
}
